import styled from "styled-components"

import Checkbox from "@irati/ui/src/FormItem/Checkbox"
import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"
import Link from "@irati/ui/src/Link"
import {CheckboxInput, CheckboxOutline} from "@irati/ui/src/FormItem/Checkbox/styled"

interface ProviderLabelProps {
  selected: boolean
}

export const ProviderLabel = styled(Flex)<ProviderLabelProps>`
  ${({theme, selected}) =>
    selected
      ? `
    border: 2px solid ${theme.colors.success};
  `
      : `
    border: 1px solid ${theme.colors.greys.lightest};
  `}
  width: 132px;
  height: 56px;
  border-radius: ${({theme}) => theme.spacing.oneAndHalf};
  background-color: ${({theme}) => theme.colors.greys.white};
  &:hover {
    width: 132px;
    height: 56px;
    background-color: ${({theme}) => theme.colors.greys.lightest};
    border: ${({theme}) => `2px solid ${theme.colors.success}`};
    cursor: pointer;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  ${CheckboxInput}:checked + ${CheckboxOutline} {
    background-color: ${({theme}) => theme.colors.secondary1};
    border: 1px solid ${({theme}) => theme.colors.secondary1};
  }
`

export const StyledIcon = styled(Icon)`
  path:last-child {
    fill: ${({theme}) => theme.colors.utility.warning};
  }
`

export const StyledLink = styled(Link)`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85%;
  cursor: pointer;
`
